import React from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Avatar from "@material-ui/core/Avatar";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemAvatar from "@material-ui/core/ListItemAvatar";
import ListItemText from "@material-ui/core/ListItemText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Dialog from "@material-ui/core/Dialog";
import PersonIcon from "@material-ui/icons/Person";
import AddIcon from "@material-ui/icons/Add";
import EditIcon from "@material-ui/icons/Edit";
import TextField from "@material-ui/core/TextField";
import Grid from "@material-ui/core/Grid";
import { blue } from "@material-ui/core/colors";
import Autocomplete from "@material-ui/lab/Autocomplete";
import IconButton from "@material-ui/core/IconButton";
import Input from "@material-ui/core/Input";
import Checkbox from "@material-ui/core/Checkbox";
import Chip from "@material-ui/core/Chip";

import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import GlobalApi from "./../../Global";
import CheckBoxIcon from "@material-ui/icons/CheckBox";
import CheckBoxOutlineBlankIcon from "@material-ui/icons/CheckBoxOutlineBlank";
import { useTranslation } from "react-i18next";
import swal from "@sweetalert/with-react";
import refresh_token from "./../../Global/refresh_token";
const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

const useStyles = makeStyles((theme) => ({
  avatar: {
    backgroundColor: blue[100],
    color: blue[600],
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
    maxWidth: 300,
  },
  chips: {
    display: "flex",
    flexWrap: "wrap",
  },
  chip: {
    margin: 2,
  },
  noLabel: {
    marginTop: theme.spacing(3),
  },
}));

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

function SimpleDialog(props) {
  const {t} = useTranslation();
  const classes = useStyles();
  const { onClose, selectedValue, open } = props;
  const [users, setUsers] = React.useState([]);
  const [sites, setSites] = React.useState([]);
  const [selectedUser, setSelectedUser] = React.useState(null);
  const [userRoles, setUserRoles] = React.useState(null);
  const [selectedSites, setSelectedSites] = React.useState([]);
  const [edit, setEdit] = React.useState(false);
  React.useEffect(() => {
    getUser();
    fetchSites();
    getHierarchyUsers();
  }, []);

  function fetchSites() {
    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let token = data.token;
    let organization_id = data.organization_id;
    let params = {
      organization_id: organization_id,
    };
    let query = Object.keys(params)
      .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(params[k]))
      .join("&");

    fetch(GlobalApi + "/Region/get_all_regions?" + query, {
      method: "get",
      headers: new Headers({
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
        Accept: "application/json",
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        let arr = [];
        data.data.map((value, index) => {
          //console.log(value.title);
          value.Areas.map((area, i) => {
            area.Sites.map((sites, j) => {
              // console.log(value.title, area.title, sites.title);
              let obj = {
                title: sites.title,
                id: sites.id,
              };
              if (sites.status !== "deactivated") {
                arr.push(obj);
              }
              //console.log(obj);
              setSites(arr);
            });
            //console.log(this.state.row);
            //console.log(result.title,value.title);
          });
        });
      });
  }

  const getUser = () => {
    let localstorage = localStorage.getItem("UserData");

    var data = JSON.parse(localstorage);
    let token = data.token;
    let params = {
      organization_id: data.organization_id,
    };
    // console.log(data.user_id);
    let query = Object.keys(params)
      .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(params[k]))
      .join("&");

    fetch(GlobalApi + "/user/get_entity?" + query, {
      method: "GET",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    })
      .then((responseJson) => responseJson.json())
      .then(async (response) => {
        if (response.status === "Success") {
          // console.log(response);
          setUsers(response.data);
        } else if (
          response.error === "jwt expired" ||
          response.error === "invalid token" ||
          response.error === "invalid signature" ||
          response.error === "Unexpected token"
        ) {
          let status = await refresh_token();
          console.log(status);
          if (status) {
            // console.log("opopopop");
            getUser();
          }
        }
      })
      .catch((error) => console.log(error.message));
  };

  const handleClose = () => {
    onClose(selectedValue);
  };

  const handleListItemClick = (value) => {
    // console.log("new user added");

    let localstorage = localStorage.getItem("UserData");
    var lol = JSON.parse(localstorage);
    let token = lol.token;
    // console.log(selectedUser);
    if (selectedUser !== null &&selectedSites.length !== 0) {
      fetch(GlobalApi + "/HierarchyUser/create_hierarchy_user", {
        method: "post",
        headers: new Headers({
          Authorization: "Bearer " + token,
          "Content-Type": "application/json",
        }),
        body: JSON.stringify({
          hierarchy_organization_id: props.id,
          user_id: selectedUser.id,
          created_by: lol.user_id,
          organization_id: lol.organization_id,
          status: "active",
        }),
      })
        .then((response) => response.json())
        .then(async (res) => {
          // console.log(res);
          if (res.status === "Success") {
            let fin_site_obj = {
              ...res.data,
              HierarchySites: [],
            };

            fin_site_obj.User.HierarchySites = [];
            selectedSites.map(async (v, i) => {
              // console.log(i, "KEY INDEX");
              let req = await fetch(
                GlobalApi + "/HierarchySite/create_hierarchy_site",
                {
                  method: "post",
                  headers: new Headers({
                    Authorization: "Bearer " + token,
                    "Content-Type": "application/json",
                  }),
                  body: JSON.stringify({
                    hierarchy_organization_id: props.id,
                    user_id: selectedUser.id,
                    created_by: lol.user_id,
                    status: "active",
                    site_id: v.id,
                  }),
                }
              );
              let resJson = await req.json();
              // console.log(resJson);
              fin_site_obj.User.HierarchySites.push(resJson.data);
              if (selectedSites?.length - 1 === i) {
                onAdd();
                getHierarchyUsers();
              }
            });
          } else {
            swal(t("Warning"), res.err, "warning");
          }
        });
    } else {
      swal(t("Warning"), t("Please Select a User / Site First"), "warning");
    }
  };

  function onAdd(data) {
    // console.log(data);
    setSelectedUser(null);
    setSelectedSites([]);
    // console.log(data)
    // setUserRoles([...userRoles, data]);
    edit === false
      ? swal(t("Success"), t("User Assigned To Role"), "success")
      : swal(t("Success"), t("User site has been updated successfully"), "success");
    setEdit(false);
  }

  async function handleSelectedUser(value) {
    if (value == null) {
      setSelectedUser(null);
      setEdit(false);
      setSelectedSites([]);
      return;
    }

    let filter_arr = await userRoles.filter((v) => v?.user_id == value.id);
    // console.log(filter_arr, value.id);

    if (filter_arr.length == 0) {
      setSelectedUser(value);
      setSelectedSites([]);
      setEdit(false);
    } else {
      let data_obj = filter_arr[0];
      let site_arr = [];

      await data_obj?.User?.HierarchySites.map((v) => {
        site_arr.push({
          title: v.Site?.title,
          id: v.Site?.id,
        });
      });
      setSelectedUser(value);
      setEdit(true);
      setSelectedSites(site_arr);
    }
  }

  async function handleEdit() {
    let localstorage = localStorage.getItem("UserData");
    var lol = JSON.parse(localstorage);
    let token = lol.token;

    let fin_site_obj = {
      ...userRoles.filter((v) => v?.user_id == selectedUser.id)[0],
    };

    fin_site_obj.User.HierarchySites = [];

    let site_obj = {};
    await selectedSites.map(async (v, i) => {
      site_obj[v.id] = v;
    });
    // console.log(site_obj)
    Object.keys(site_obj).map(async (key, i) => {
      // console.log(site_obj[key], "REQURST DATA");
      // return
      if (key == undefined) {
        return;
      }
      let req = await fetch(GlobalApi + "/HierarchySite/edit_hierarchy_site", {
        method: "post",
        headers: new Headers({
          Authorization: "Bearer " + token,
          "Content-Type": "application/json",
        }),
        body: JSON.stringify({
          hierarchy_organization_id: props.id,
          user_id: selectedUser.id,
          created_by: lol.user_id,
          status: "active",
          site_id: site_obj[key].id,
          delete: i == 0,
        }),
      });
      let resJson = await req.json();
      console.log(resJson);
      fin_site_obj.User.HierarchySites.push(resJson.data);
      if (selectedSites?.length - 1 === i) {
        onAdd();
        getHierarchyUsers();
      }
    });
  }

  function getHierarchyUsers() {
    let localstorage = localStorage.getItem("UserData");
    var lol = JSON.parse(localstorage);
    let token = lol.token;
    let params = {
      hierarchy_organization_id: props.id,
    };

    let query = Object.keys(params)
      .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(params[k]))
      .join("&");
    // console.log(
    //   GlobalApi + "/HierarchyUser/get_all_hierarchy_organization_users?" + query
    // );
    fetch(
      GlobalApi +
        "/HierarchyUser/get_all_hierarchy_organization_users?" +
        query,
      {
        method: "GET",
        headers: {
          Authorization: "Bearer " + token,
          "Content-Type": "application/json",
        },
      }
    )
      .then((responseJson) => responseJson.json())
      .then(async (response) => {
        setUserRoles(response.data);
      });
  }

  // console.log(selectedSites, userRoles);

  function isCheck(name) {
    console.log(
      // name, "CHECK VALUE COND",selectedSites?.filter((v) => v.id == name.id).length,
      selectedSites?.filter((v) => v.id == name.id).length == 1
    );
    return selectedSites?.filter((v) => v.id == name.id).length == 1;
    // || selectedSites?.filter((v) => v.id == name.id).length !== 2;
  }

  return (
    <Dialog
      onClose={handleClose}
      aria-labelledby="simple-dialog-title"
      open={open}
      style={{ zIndex: 0 }}
    >
      <DialogTitle id="simple-dialog-title">Users List</DialogTitle>
      <List style={{ maxHeight: "60vh", overflow: "auto" }}>
        {userRoles?.map((value) => {
          // console.log(value);
          return (
            <ListItem
              button
              onClick={() => handleSelectedUser(value?.User)}
              // key={value.id}
            >
              <Grid container>
                <Grid item>
                  <ListItemAvatar>
                    <Avatar className={classes.avatar}>
                      <PersonIcon />
                    </Avatar>
                  </ListItemAvatar>
                </Grid>
                <Grid item>
                  <ListItemText
                    primary={`${value?.User?.first_name} ${
                      value?.User?.last_name
                    }`}
                  />
                </Grid>
                <Grid item>
                  {value?.User?.HierarchySites.map((v) => {
                    return (
                      <Chip
                        label={`${v.Site?.title}`}
                        style={{ margin: 2 }}
                        variant="outlined"
                        size="small"
                      />
                    );
                  })}
                </Grid>
              </Grid>
            </ListItem>
          );
        })}
      </List>
      <ListItem>
        {/* <div style={{ margin: 5 }}> */}

        <Grid container spacing={1}>
          <Grid item xs={12}>
            <Autocomplete
              id="country-select-demoss"
              fullWidth
              options={users}
              autoHighlight
              value={selectedUser}
              defaultValue={selectedUser}
              getOptionLabel={(option) =>
                `${option.first_name} ${option.last_name}`
              }
              renderOption={(option) => (
                <React.Fragment style={{ zIndex: 3 }}>
                  {option.first_name} {option.last_name}
                </React.Fragment>
              )}
              style={{ zIndex: 3 }}
              onChange={(e, v) => handleSelectedUser(v)}
              // value={selectedUser}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Users"
                  variant="outlined"
                  inputProps={{
                    ...params.inputProps,
                    // autoComplete: "new-password",
                  }}
                />
              )}
            />
          </Grid>
          <Grid item xs={12}>
            <Autocomplete
              id="country-select-demoss"
              fullWidth
              options={sites}
              autoHighlight
              getOptionLabel={(option) => `${option.title}`}
              getOptionSelected={(option, value) => value.id === option.id}
              renderOption={(option, { selected }) => (
                <React.Fragment>
                  <Checkbox
                    icon={icon}
                    checkedIcon={checkedIcon}
                    style={{ marginRight: 8 }}
                    checked={selected}
                  />
                  {option.title}
                </React.Fragment>
              )}
              multiple
              onChange={(e, v) => setSelectedSites(v)}
              value={selectedSites}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Sites"
                  variant="outlined"
                  inputProps={{
                    ...params.inputProps,
                    // autoComplete: "new-password",
                  }}
                />
              )}
            />
          </Grid>
        </Grid>

        {edit == false ? (
          <IconButton
            variant="outlined"
            color="primary"
            style={{ margin: 5 }}
            onClick={() => handleListItemClick("addAccount")}
          >
            <AddIcon />
          </IconButton>
        ) : (
          <IconButton
            variant="outlined"
            color="primary"
            style={{ margin: 5 }}
            onClick={() => handleEdit("editAccount")}
          >
            <EditIcon />
          </IconButton>
        )}
      </ListItem>
    </Dialog>
  );
}

SimpleDialog.propTypes = {
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  selectedValue: PropTypes.string.isRequired,
};

export default function UserHierarchy(props) {
  const [open, setOpen] = React.useState(props.open);

  const [data] = React.useState(props?.HierarchyUsers);
  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = async (value) => {
    setOpen(false);
  };

  return (
    <div>
      <Button
        variant="outlined"
        size="small"
        color="default"
        onClick={handleClickOpen}
      >
        Users
      </Button>
      <SimpleDialog
        open={open}
        onClose={handleClose}
        // data={data}
        id={props.id}
      />
    </div>
  );
}
